import { MediaFileUtils, MimeCodecsString } from "audio_input";
import { LCAppId } from "../data/constants/LCAppId";

export function getIndexPageUi():HTMLDivElement {
	switch (AppSettings.lcAppId){
		case LCAppId.main: {
			return document.body.querySelector("#indexScreen");
		}
		case LCAppId.recorderLoops: {
			return document.body.querySelector("#recorderIndexScreen");
		}
		case LCAppId.bandLoops: {
			return document.body.querySelector("#bandIndexScreen");
		}
		case LCAppId.easyLoops: {
			return document.body.querySelector("#easyLoopsIndexScreen");
		}
	}
}

export class AppSettings {
	public static readonly useIdxDb:boolean = true;
	
	private static _jsParams:any;
	private static _isBot:boolean;
	private static _isGuest:boolean;
	private static _appLoadComplete:boolean = false;
	
	public static init():void {
		this._jsParams = window['params'];
		
		let rx = /bot|googlebot|crawler|spider|robot|crawling/i;
		AppSettings._isBot = (rx.test(window.navigator.userAgent) ||
			AppSettings.getJSParam("fakeBot") === true);
		
		AppSettings._isGuest = AppSettings.getJSParam("tryAsGuest");
	}
	
	public static getJSParam(paramName:string):any {
		if (AppSettings._jsParams.hasOwnProperty(paramName)){
			return AppSettings._jsParams[paramName];
		}
		else {
			return null;
		}
	}
	
	public static handleAppLoadComplete():void {
		AppSettings._appLoadComplete = true;
	}
	
	public static get appLoadComplete():boolean {
		return AppSettings._appLoadComplete;
	}
	
	public static get lcAppId():LCAppId {
		return window["LCAppId"];
	}
	
	public static get allowSignin():boolean {
		return (AppSettings.lcAppId === LCAppId.main);
	}

	public static get skipSecondSigninPage():boolean {
		return true;
	}
	
	public static get allowCommunities():boolean {
		return (AppSettings.lcAppId === LCAppId.main);
	}
	
	public static get allowMusicXmlOpen():boolean {
		return true;
	}
	
	public static get allowSongManagement():boolean {
		return (AppSettings.lcAppId === LCAppId.main);
	}
	
	public static get allowSessions():boolean {
		return (AppSettings.lcAppId === LCAppId.main);
	}
	
	public static get allowLessons():boolean {
		return (AppSettings.lcAppId === LCAppId.main);
	}
	
	public static get showActivityPanel():boolean {
		return (AppSettings.lcAppId === LCAppId.main);
	}
	
	public static get showProApMenuItem():boolean {
		return (AppSettings.lcAppId === LCAppId.main);
	}
	
	public static get useSignalR():boolean {
		return (AppSettings.lcAppId === LCAppId.main); 
	}
	
	public static get isBot():boolean {
		return AppSettings._isBot;
	}
	
	public static get resourcesPath():string {
		return AppSettings.getJSParam("resourcesUrl");
	}
	
	public static get pageUrl():string {
		return AppSettings.getJSParam("pageUrl");
	}
	
	public static get serverRoot():string {
		return AppSettings.getJSParam("serverRoot");
	}
	
	public static get videoEmbedId():string {
		return AppSettings.getJSParam("videoEmbedId");
	}
	
	public static get soundTouchWorkletUrl():string {
		return AppSettings.getJSParam("soundTouchWorkletUrl");
	}
	
	public static get phazeWorkletUrl():string {
		return AppSettings.getJSParam("phazeWorkletUrl");
	}
	
	public static get signalSmithWorkletUrl():string {
		return AppSettings.getJSParam("signalSmithWorkletUrl");
	}
	
	public static get signalSmithIframeUrl():string {
		return AppSettings.getJSParam("signalSmithIframeUrl");
	}
	
	public static get allowGuests():boolean {
		return true;
		return (AppSettings.queryParams.showGuestStart === "1");
	}
	
	public static get isGuest():boolean {
		return AppSettings._isGuest;
	}
	
	public static get jumpToCheckout():boolean {
		return (AppSettings.queryParams.checkout === "1");
	}
	
	public static get stripePublicKey():string {
		return AppSettings.getJSParam("stripePublicKey");
	}
	
	public static get externalUrl():string {
		return AppSettings.getJSParam("externalUrl");
	}
	
	public static get queryParams():QueryParams {
		let params = AppSettings.getJSParam("queryParams") as QueryParams;
		if (params == null){
			params = {} as QueryParams;
		}
		return params;
	}
	
	/////VIDEO//////
	public static get preferredVideoMimeCodecsStrings() {
		return [
			MimeCodecsString.videoWebmAvc1,
			MimeCodecsString.videoMp4Avc1,
			// MimeCodecsString.videoWebmVp8 //for Firefox support
		];
	}
	
	public static get videoMimeCodecsString() {
		return AppSettings._videoMimeCodecsString;
	}
	private static _videoMimeCodecsString = null;
		
	public static get isVideoSupported():boolean {
		return (AppSettings._videoMimeCodecsString != null);
	}
	public static get isUsingPreferredVideo() {
		return AppSettings._videoMimeCodecsString ===
			AppSettings.preferredVideoMimeCodecsStrings[0];
	}
	public static get videoMimeType() {
		return MediaFileUtils.getMimeType(AppSettings._videoMimeCodecsString);
	}
	public static get failOnNoVideoSupport():boolean {
		return true;
	}
	
	public static chooseBestVideoSettings():void {
		for (let option of AppSettings.preferredVideoMimeCodecsStrings){
			if (MediaFileUtils.isMimeCodecSupported(option)){
				AppSettings._videoMimeCodecsString = option;
				break;
			}
		}
	}
	
	/////AUDIO//////
	public static get preferredAudioMimeCodecsStrings() {
		return [
			MimeCodecsString.audioWebmOpus,
			MimeCodecsString.audioMp4Avc1
		];
	}
	
	public static get audioMimeCodecsString() {
		return AppSettings._audioMimeCodecsString;
	}
	private static _audioMimeCodecsString = null;
	
	
	public static get isAudioSupported():boolean {
		return (AppSettings._audioMimeCodecsString != null);
	}
	public static get isUsingPreferredAudio() {
		return AppSettings._audioMimeCodecsString ===
			AppSettings.preferredAudioMimeCodecsStrings[0];
	}
	public static get audioMimeType() {
		return MediaFileUtils.getMimeType(AppSettings._audioMimeCodecsString);
	}
	public static get failOnNoAudioSupport():boolean {
		return true;
	}
	
	public static chooseBestAudioSettings():void {
		for (let option of AppSettings.preferredAudioMimeCodecsStrings){
			if (MediaFileUtils.isMimeCodecSupported(option)){
				AppSettings._audioMimeCodecsString = option;
				break;
			}
		}
	}
}

export interface QueryParams {
	/**song id */
	id: string | undefined;
	
	skipToSignin: string | undefined;
	
	/**https://firebase.google.com/docs/auth/custom-email-handler#web_6 */
	/**fb user management action */
	mode: "resetPassword" | "recoverEmail" | "verifyEmail" | undefined;
	/**A one-time code, used to identify and verify a request */
	oobCode: string | undefined;
	/**Firebase project's API key, provided for convenience */
	apiKey: string | undefined;
	continueUrl: string | undefined;
	lang: string | undefined;
	/**pro=1 means pro purchases are allowed */
	pro: string | undefined;
	/**localStorageOff=1 means settings should not be loaded from local
	 * storage. Can still be saved to it. */
	localStorageOff: string | undefined;
	showGuestStart: string | undefined;
	checkout: string | undefined;
}